import * as types from './courseInitiative.types'

const initialState = {
	isLoading: false,
	isSuccess: false,
	courseInitiative: {
		initiative_id: null,
		valid_from: null,
		valid_to: null,
	},
	options: {},
	permissions: {},
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.TOGGLE_LOADING:
			return {
				...state,
				isLoading: payload,
			}
		case types.SET_COURSE_INITIATIVE:
			return {
				...state,
				courseInitiative: payload,
			}
		case types.TOGGLE_SUCCESS:
			return {
				...state,
				isSuccess: payload,
			}
		case types.SET_OPTIONS:
			return {
				...state,
				options: payload,
			}
		case types.CLEAR_DATA:
			return {
				...state,
				courseInitiative: initialState.courseInitiative,
			}
		case types.SET_PERMISSIONS:
			return {
				...state,
				permissions: payload,
			}
		default:
			return state
	}
}
